module.exports = __webpack_public_path__ + "img/Cafe.7a7b2e04.png";